// extracted by mini-css-extract-plugin
module.exports = {"groupText":"fRHSri","label":"d26ypj","textProtocol":"LYhuVc","highlighted":"_258Edq","textContainer":"_8JeoG_","unverifiedSpecialCaseText":"S_cfY8","additionalInfo":"qbO085"};